export default "__VITE_ASSET__$t47_TfC__"